export const categories = {
   Accounting: [
      'Accounting Management',
      'Accounts Payable/Accounts Receivable/Bookkeeping',
      'Corporate Accounting - Entry Level',
      'Corporate Accounting - Senior',
      'Others',
      'Public Accounting - Entry Level',
      'Public Accounting - Senior'
   ],
   'Administrative / Clerical': [
      'Administrative Support - General',
      'Data Entry/Typist/Word Processor',
      'Executive Secretary',
      'File/Mail/Record Clerk',
      'Legal Secretary/Paralegal',
      'Others',
      'Receptionist/Telephone Operator'
   ],
   'Advertising / Marketing / PR': [
      'Account Executive/Manager',
      'Art Director',
      'Brand Ambassador',
      'Copywriter And Proposal Writer',
      'Digital Marketer/Community Relations Manager',
      'Event Coordinator/Planner',
      'Graphic Designer',
      'Marketer/Market Researcher/Data Analyst',
      'Marketing Director',
      'Media Planner/Buyer',
      'Others'
   ],
   Agriculture: [
      'Agronomist',
      'Apprentice/Intern',
      'Farm/Ranch Assistant',
      'Farm/Ranch Management',
      'Farm/Ranch Operations',
      'Others',
      'Plant/Mill Management/Administration',
      'Plant/Mill Operations',
      'Sales - Agricultural Product',
      'Sales - Equipment'
   ],
   'Automotive / Mechanic': [
      'Auto Body Painter',
      'Auto Collision Estimator/Service Adviser',
      'Auto Parts Manager/Counter Person',
      'Auto Sales/Dealer',
      'Assembler',
      'Designer/Engineer',
      'Mechanic/Technician',
      'Diesel Mechanic/Technician',
      'Finance And Insurance Manager',
      'Others',
      'Title Clerk'
   ],
   'Airline / Aviation': [
      'Air Traffic Control',
      'Aircraft Mechanic/Technician',
      'Aircraft Sales',
      'Airport/Ground Operations Manager',
      'Airport/Ground Staff',
      'Engineering/Design',
      'Pilot/Flight Operations',
      'Training/Instruction'
   ],
   'Bilingual Services / Interpretation / Translation': [
      'All'
   ],
   'Caregiving / Babysitting': [
      'Babysitter/Child Caregiver',
      'Housekeeper/Maid',
      'Nanny/Au Pair',
      'Personal Assistant',
      'Pet Care',
      'Senior Care'
   ],
   'Construction / Facilities / Trades': [
      'Architect',
      'Carpenter',
      'Civil Engineer',
      'Cost Estimator',
      'Electrical Engineer',
      'HVAC Mechanic',
      'Heavy Equipment Operator',
      'IT',
      'Inspector And Surveyor',
      'Ironworker/Welder',
      'Laborer',
      'Mason',
      'Others',
      'Plumber/Pipefitter',
      'Superintendent/Manager',
      'Surveying And Mapping Technician'
   ],
   'Consumer Products / CPG / Packaging': [
      'All'
   ],
   'Customer Service / Call Center / Telemarketing': [
      'Call Center/Customer Service Manager',
      'Call Center/Customer Service Representative',
      'Collections',
      'Customer Service Analyst',
      'Helpdesk',
      'Telemarketing/Inside Sale'
   ],
   'Military / Defense': [
      'Confidential',
      'DoE/DoJ And Other Clearances',
      'Others',
      'Secret',
      'Top Secret',
      'Top Secret - SCI'
   ],
   'Education / Teaching': [
      'Excluding Post Secondary Administrative Support And Student Affairs',
      'Excluding Post Secondary Executive Management',
      'Excluding Post Secondary Others',
      'Excluding Post Secondary Teacher, Early Childhood Education',
      'Excluding Post Secondary Teacher, Elementary School',
      'Excluding Post Secondary Teacher, Middle School And High School',
      'Excluding Post Secondary Teacher, Special Education',
      'Excluding Post Secondary Teacher/Tutor, Extracurricular',
      'Post Secondary Business And Operational Support',
      'Post Secondary Executive Management',
      'Post Secondary Faculty, Business And Law',
      'Post Secondary Faculty, Engineering',
      'Post Secondary Faculty, Health And Medicine',
      'Post Secondary Faculty, Humanities',
      'Post Secondary Faculty, Mathematics And Natural Sciences',
      'Post Secondary Faculty, Professions',
      'Post Secondary Faculty, Social Sciences',
      'Post Secondary Faculty, Vocational And Technical Education',
      'Post Secondary Others',
      'Post Secondary Student Affairs'
   ],
   'Electronics / Computer Hardware': [
      'Hardware Engineer/Designer',
      'Hardware Test Engineer',
      'Others',
      'Semiconductor Processing'
   ],
   'Energy / Power / Utilities': [
      'Engineering, Civil And Mechanical',
      'Engineering, Electrical And Nuclear',
      'Engineering, Petroleum And Chemical',
      'Field And Refinery Operations',
      'Field And Refinery Operations Management',
      'Geology/Geophysics',
      'Health, Environment And Safety',
      'Others',
      'Power Plant Operations',
      'Procurement/Purchasing',
      'Sales/Marketing',
      'Scheduling And Dispatching'
   ],
   'Arts / Entertainment': [
      'Administrative And Operational Support',
      'Agent/Manager',
      'Choreographer/Dancer',
      'Comedian',
      'Film/TV/Music Studio Crew',
      'Film/TV/Video Cast',
      'Film/TV/Video Producer And Director',
      'Music Producer',
      'Musician/Singer/Composer',
      'Others',
      'Stage Staff/Tech',
      'Theater Performer',
      'Voice Over',
      'Writer/Editor'
   ],
   'Management (Executive)': [
      'Accounting/Finance',
      'Administrative/Operational Support',
      'Chief Executive/General Management',
      'Engineering/Production',
      'Human Resources',
      'Information Technology',
      'Marketing/Public Relations',
      'Procurement/Supply Chain',
      'Sales/Business Development'
   ],
   'Fashion / Beauty / Grooming': [
      'Advertising/Marketing/Public Relations',
      'Design',
      'IT/E-Commerce',
      'Internship',
      'Model/Styling',
      'Others',
      'Patternmaking/Production',
      'Purchasing/Merchandising',
      'Retail/Sales/Account Management',
      'Visual Merchandising'
   ],
   'Banking / Mortgage / Finance': [
      'Banking/Investment/Finance',
      'Banking/Investment/Finance Banker/Loan Officer',
      'Banking/Investment/Finance Financial Analyst/Examiner',
      'Banking/Investment/Finance General Operational Manager',
      'Banking/Investment/Finance Loan Processor',
      'Banking/Investment/Finance Others',
      'Banking/Investment/Finance Securities Broker',
      'Banking/Investment/Finance Teller',
      'Insurance',
      'Insurance Actuary',
      'Insurance Claim Adjuster',
      'Insurance Insurance Sales Agent/Broker',
      'Insurance Others',
      'Insurance Underwriter'
   ],
   'Government / Civil Service': [
      'Accounting/Finance',
      'Administrative And Operational Support',
      'Animal/Forestry/Environment',
      'Architecture/Engineering',
      'Community And Social Services',
      'Education',
      'Facility Maintenance',
      'Healthcare',
      'IT And Computer Systems',
      'Law Enforcement/Fire',
      'Legal/Compliance',
      'Library/Museum',
      'Logistics/Transportation',
      'Others',
      'Public Affairs',
      'Science/Research'
   ],
   'Graphic Design / CAD': [
      'All'
   ],
   'Healthcare / Allied Health / Wellness': [
      'Dietitian/Nutritionist',
      'Emergency Medical Technician/Paramedic',
      'Medical Assistant',
      'Medical Biller/Coder',
      'Medical Technologist (MLS)',
      'Nursing Assistant/Patient Care Technician',
      'Nursing Assistant/Patient Care Technician',
      'Occupational Therapist',
      'Others',
      'Pharmacist',
      'Phlebotomist',
      'Physical Therapist',
      'Physician Assistant',
      'Radiographer',
      'Recreational/Expressive Therapist',
      'Respiratory Therapist',
      'Social Worker/Counselor',
      'Sonographer',
      'Speech And Language Pathologist (Therapist)',
      'Surgical Assistant/Technologist',
      'Dental Assistant',
      'Dental Technician',
      'General Dentist',
      'Oral/Maxillofacial Surgeon',
      'Orthodontist/Prosthodontist'
   ],
   'Healthcare / Physician / Nursing': [
      'Advanced Practice Registered Nurse (APRN)',
      'Licensed Practical Nurse (LPN/LVN)',
      'Nursing Manager',
      'Registered Nurse (RN/BSN/ASN)',
      'Anesthesiology',
      'Cardiology',
      'Critical Care',
      'Dermatology',
      'Family Medicine/General Practice',
      'General Surgery',
      'HIV/Infectious Diseases',
      'Internal Medicine',
      'Neurology',
      'OB/GYN And Women\'s Health',
      'Oncology',
      'Ophthalmology',
      'Optometry',
      'Orthopedic Surgery',
      'Others',
      'Pathology',
      'Pediatrics',
      'Plastic Surgery',
      'Psychiatry',
      'Radiology',
      'Urology'
   ],
   'Hospitality / Hotel': [
      'Food Services Bartender',
      'Food Services Busser',
      'Food Services Chef - Commercial Kitchen',
      'Food Services Cook - Commercial Kitchen',
      'Food Services Cook/Chef - Personal/Private',
      'Food Services Dishwasher',
      'Food Services General Operations Manager - Food Services',
      'Food Services Others',
      'Food Services Waiter/Server',
      'Lodging/Resort/Travel',
      'Lodging/Resort/Travel Bellperson/Concierge/Host',
      'Lodging/Resort/Travel Camp Staff',
      'Lodging/Resort/Travel Esthetician/Nail Tech/Hairdresser',
      'Lodging/Resort/Travel Flight Attendent',
      'Lodging/Resort/Travel Gaming Service Supervisor',
      'Lodging/Resort/Travel Gaming Service Worker',
      'Lodging/Resort/Travel Housekeeper',
      'Lodging/Resort/Travel Massage Therapist',
      'Lodging/Resort/Travel Others',
      'Lodging/Resort/Travel Tour Guide',
      'Lodging/Resort/Travel Valet/Parking Attendant'
   ],
   'HR / Staffing / Training': [
      'Assistant/Intern',
      'Resources Director/VP/CHRO',
      'Generalist',
      'Others',
      'Human Resources Specialist - Compensation/Benefit/Payroll',
      'Human Resources Specialist - Employee/Labor Relations',
      'Human Resources Specialist - Information Systems (HRIS)',
      'Human Resources Specialist - Learning And Development',
      'Human Resources Specialist - Recruiting'
   ],
   'IT / Software / Systems': [
      'Business Systems Analyst And IT Consultant',
      'Chief Executive (Director/CIO/CTO)',
      'Data Architect/Analyst/Administrator',
      'IT Helpdesk/Technical Support',
      'Information Security Specialist/Forensics',
      'Mobile Developer',
      'Others',
      'Project And Product Manager',
      'Software Architect And Senior Engineer',
      'Software Engineer, Developer, And Programmer',
      'Software Quality Assurance Analyst',
      'System Architect And Senior Engineer',
      'System Engineer And Technician',
      'Systems And Network Administrator',
      'Technical Writer/Documentation Specialist',
      'UX/UI Designer',
      'Web Developer'
   ],
   'Design / Decorating': [
      'All'
   ],
   'Law Enforcement / Security': [
      'Correctional Officer',
      'Criminologist And Forensic Scientist',
      'Detective/Investigator',
      'Dispatcher',
      'Immigration/Border Control Officer',
      'Others',
      'Police Chief',
      'Police Commander/Captain',
      'Police Officer/Deputy Sheriff',
      'Security Officer/Guard'
   ],
   'Legal / Lawyer': [
      'Legal Attorney - Corporate',
      'Legal Attorney - Firm',
      'Legal Secretary/Paralegal',
      'Legal Others'
   ],
   'Manufacturing / Industrial / Mining': [
      'Administrative And Operational Support',
      'And Extraction Operations',
      'Engineering',
      'Environment, Health And Safety',
      'Exploration And Geoscience',
      'Extraction/Production Management',
      'Others',
      'Refinement Operations'
   ],
   'Driver / Transportation / Maritime': [
      'CDL-A Driver - Company',
      'CDL-A Driver - Owner Operator',
      'Trucking CDL-B Driver/CDL-C Driver',
      'Fleet Management',
      'Others',
      'Team Driver',
      'Trainee/Inexperienced Driver'
   ],
   'Publishing / Journalism / Media': [
      'Bindery/Finisher',
      'Estimator/Account Manager',
      'Ink Technician',
      'Operations Manager',
      'Packaging Operator',
      'Prepress',
      'Press Operator - Digital/Reprographic',
      'Press Operator - Flexographic/Screen',
      'Press Operator - Sheetfed',
      'Press Operator - Web'
   ],
   'Other / Miscellaneous': [
      'Miscellaneous All'
   ],
   'Non-Profit / Fundraising': [
      'Accounting And Finance',
      'Administrative And Operational Support',
      'Development/Fundraising/Donor Relations',
      'Executive Management',
      'Grant Administration',
      'Others',
      'Program Development/Management',
      'Program Staff',
      'Public Relations/Marketing',
      'Volunteer Management'
   ],
   'Biotech / Pharmaceutical': [
      'Biostatistician',
      'Brand/Product Manager',
      'Engineer',
      'Medical Affairs',
      'Medical Writer',
      'Pharmacist',
      'Principal Investigator',
      'Research Associate/Quality Control',
      'Research Coordinator',
      'Research Fellow/Scientist',
      'Sales',
      'Technician/Operational Staff'
   ],
   'Real Estate / Property Mgmt': [
      'Broker/Agent - Commercial Real Estate',
      'Broker/Agent - Residential Real Estate',
      'Community/Property Manager',
      'Leasing Manager/Consultant',
      'Others',
      'Real Estate Analyst',
      'Real Estate Attorney',
      'Real Estate Director/Manager',
      'Real Estate Title Agent'
   ],
   Retail: [
      'Administrative And Operational Support',
      'Customer Service/Sales',
      'Loss Prevention',
      'Management',
      'Merchandising/Stocking',
      'Others'
   ],
   Sales: [
      'Cashier/Counter Person',
      'Real Estate Agent/Broker',
      'Retailer',
      'Sales - Business Services',
      'Sales - Insurance',
      'Sales - Securities/Financial Services',
      'Sales - Wholesaler/Manufacturer',
      'Sales Engineer',
      'Telemarketer',
      'Travel Agent'
   ],
   'Science / Research': [
      'Biology/Bioengineering',
      'Chemistry/Material Science',
      'Economics',
      'Education',
      'Electronic Engineering/Computer Science',
      'Environmental Science',
      'Geoscience/Earth Science',
      'Health/Medicine/Pharmacology',
      'Humanities',
      'Mathematics',
      'Neuroscience/Psychology',
      'Others',
      'Physics',
      'Political Science',
      'Statistics'
   ],
   'Social Services / Counseling': [
      'All'
   ],
   'Sports / Fitness / Recreation': [
      'Athletic Director',
      'Coach - Collegiate',
      'Coach - Pre-Collegiate',
      'Facility Operations - Manager',
      'Facility Operations - Staff',
      'Intern/Entry-Level Sports Marketing',
      'Others',
      'Referee/Umpire/Sports Official',
      'Sports Agent',
      'Sports Broadcaster/Reporter/Journalist/Analyst',
      'Sports Information Director',
      'Vendor/Ticket Sales'
   ],
   'Telecom / Wireless / Cable': [
      'Accounting And Finance',
      'Administrative/Clerical',
      'Customer Service/Call Center',
      'Field Installation',
      'Marketing',
      'Network/Systems/Wireless',
      'Others',
      'Software'
   ],
   'Veterinary Services': [
      'Boarding/Grooming',
      'Office Staff',
      'Others',
      'Practice Manager',
      'Research/Lab Technician',
      'Sales',
      'Veterinarian',
      'Veterinary Assistant/Technician'
   ],
   'Warehouse / Logistics / Distribution': [
      'Customs Brokerage',
      'Freight Broker/Sales',
      'Freight Forwarding',
      'Others',
      'Warehouse/Logistics Management',
      'Warehouse/Logistics Operations'
   ]
};
